import { toast } from 'react-toastify';
import axiosInstance from '../Hooks/services/axiosInstance';
const prepareColumnsForExport = (visibleColumns, tableHeader) => {
  return tableHeader
    .filter((col) => visibleColumns[col.key])
    .map((col) => ({
      key: col.key,
      header: col.title,
      width: 20,
    }));
};
export const handleExport = async (exportData) => {
  try {
    let response;

    if (exportData?.isData) {
      response = exportData?.combinedData;
    } else {
      if (exportData?.method === 'get') {
        response = await axiosInstance.get(exportData?.api, {
          params: exportData?.payload,
        });
      } else {
        response = await axiosInstance.post(
          exportData?.api,
          exportData?.payload,
        );
      }
    }
    const data = (exportData?.isData ? response : response?.data?.items) || [];

    const exportColumns = prepareColumnsForExport(
      exportData?.visibleColumn,
      exportData?.tableHeader,
    );

    await exportToExcel(data, exportColumns, exportData?.fileName);
  } catch (error) {
    toast.error('Something went wrong');
  } finally {
    toast.success('Exported Successfully');
  }
};

export async function exportToExcel(data, columns, filename) {
  const XLSX = await import('xlsx');

  // Build headers
  const headers = columns.map((col) => col.header);

  // Build data rows
  const rows = data.map((row) =>
    columns.map((col) => {
      // If accessor is a function
      if (typeof col.key === 'function') {
        return col.key(row) ?? '';
      }

      // Handle nested keys like 'category.name'
      const keys = col.key.split('.');
      let value = row;

      for (const key of keys) {
        value = value?.[key];
        if (value === undefined || value === null) break;
      }

      return value ?? '';
    }),
  );

  // Create worksheet
  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

  // Set column widths
  worksheet['!cols'] = columns.map((col) => ({
    wch: col.width || 20,
  }));

  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

  // Generate file and trigger download
  const buffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}
